import { GetStaticProps, GetStaticPaths } from 'next';

import DynamicArticle from './DynamicArticle';

import { getArticlesPageStaticProps } from 'services/staticGeneration/articlesPage';
import { getArticlePageStaticPaths } from 'services/incrementalStaticGeneration/articlesPage';

export const getStaticProps: GetStaticProps = getArticlesPageStaticProps;
export const getStaticPaths: GetStaticPaths = getArticlePageStaticPaths;

export default DynamicArticle;
